
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/audiobooks/[slug]",
      function () {
        return require("private-next-pages/audiobooks/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/audiobooks/[slug]"])
      });
    }
  